module.exports = __webpack_public_path__ + "static/media/btn_google_signin_2x.24c8fcd1.png";